export const WHATSAPP_NUMBER = "351962252659";
export const PHONE_DISPLAY = "+351 962 252 659";
export const EMAIL = "magnolialunarspa@gmail.com";
export const ADDRESS = "Av. Fontes Pereira de Melo 35, 1050-118 Lisboa";
export const MAPS_LINK = "https://share.google/B8hoSqFeMiwQX7Z8v";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const openWhatsApp = (text) => {
  window.open(waLink(text), "_blank", "noopener,noreferrer");
};

// Legacy Cloudflare R2 prefix — kept ONLY as a safety net to auto-rewrite any
// stray legacy URL that may still slip through from old DB records into the UI.
// The backend runs a proper DB migration at startup; this is belt-and-braces.
const LEGACY_R2_PREFIX = "https://pub-b0c6576fd7ce4550917b484175556894.r2.dev";

function localizeLegacyR2(url) {
  if (typeof url !== "string" || !url) return url;
  if (!url.startsWith(LEGACY_R2_PREFIX)) return url;
  let tail = url.slice(LEGACY_R2_PREFIX.length);
  if (!tail.startsWith("/")) tail = "/" + tail;
  let localPath = `/api/files/magnolia-lunar/cdn${tail}`;
  const last = localPath.split("/").pop() || "";
  if (!last.includes(".")) localPath += ".jpg";
  return localPath;
}

// Resolve image URLs:
//  - Legacy R2 URLs are rewritten to the local /api/files/ path served by the backend.
//  - Other absolute URLs (Unsplash hero, etc.) pass through unchanged.
//  - Relative paths (/api/files/...) are prefixed with REACT_APP_BACKEND_URL.
export const imgUrl = (src) => {
  if (!src) return "";
  const localized = localizeLegacyR2(src);
  if (localized.startsWith("http")) return localized;
  return `${process.env.REACT_APP_BACKEND_URL}${localized}`;
};
